<template>
  <ul
    class="list list--margin-top"
    :class="{
      'list--fdm-background': backgroundFdm,
      'list--no-padding': noPadding,
    }"
  >
    <slot name="list-item" />
  </ul>
</template>

<script>
export default {
  props: {
    backgroundFdm: Boolean,
    noPadding: Boolean,
  },
}
</script>

<style scoped>
.list {
  padding: 0.5rem;
  margin: 0;
}
.list--no-padding {
  padding: 0;
}
.list--fdm-background {
  background-image: url('~assets/images/backgrounds/bg-kitch/bg-kitch.png');
  background-repeat: repeat;
}
</style>
